import React from 'react'

import {Icon} from '../../../../shared/tr-icons'
import {populateString} from '../../utils/strings'
import {SearchWrapper, TextInput, IconContainer} from './HeaderSearch.styles'

const HeaderSearchComponent = ({value, focus, events, i18n}) => {
  return (
    <SearchWrapper className={focus ? 'focus' : ''}>
      <TextInput
        placeholder={populateString(i18n.search, ['100 records'])}
        data-testid='search-input'
        type='text'
        value={value}
        onFocus={events.handleFocus}
        onBlur={events.handleBlur}
        onChange={events.handleChange}
        onKeyUp={events.handleEnter}
      />

      <IconContainer>
        {value !== '' && (
          <Icon type='clearOutline' data-testid='search-clear' onClick={events.handleClear} />
        )}
        {value === '' && <Icon type='search' data-testid='search-search' />}
      </IconContainer>
    </SearchWrapper>
  )
}

export default HeaderSearchComponent
